/* eslint-disable react/prop-types */
import React, { Component } from "react";
import axios from "axios";
import { TextField, MenuItem as MuiMenuItem } from "@material-ui/core";
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";
import { Button, Popover } from "antd";
import { InfoCircleOutlined, CheckCircleOutlined } from "@ant-design/icons";
import DialogSuccess from "../../components/Dialog/DialogSuccess";
import DialogError from "../../components/Dialog/DialogError";
import FooterComponent from "../../components/FooterComponent";
import config from "../../config";
import moment from "moment";
import "./style.css";
import "../../assets/bootstrap.css";
import PaymentLoader from "../../components/PaymentLoader";
import { trackInitiateBooking } from "../../utils/metaPixel";

class JoyRideBookingComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      loadingMessage: "Hold tight! your booking is in progress...",
      block: false,
      bookingId: null,
      bookingAdmin: null,
      successMessage: "",
      email: "",
      mobileNumber: "",
      seats: 1,
      passengers: [],
      grandprice: "",
      errors: {
        email: false,
        mobileNumber: false,
        passengers: {
          name: [],
          age: [],
          weight: [],
          idNumber: [],
        },
      },
      travelDate: null,
      selectedDateFormatted: null,
      selectedScheduleObj: null,
      bookingResponse: {},
      dialog: {
        error: false,
        success: false,
      },
      isFormValid: true,
    };
  }

  getQueryParam = (key) => {
    const { search } = this.props.location;
    let value = null;
    search
      .replace("?", "")
      .split("&")
      .some((param) => {
        const [paramKey, paramValue] = param.split("=");

        if (key === paramKey) {
          value = paramValue;
          return false;
        }
        return true;
      });

    return value;
  };

  async componentDidMount() {
    const pageState = this.props.history.location.state;
    const bookingId = this.getQueryParam("id");
    if (bookingId) {
      const { booking } = await axios
        .get(config.baseUrl + "v2/booking/block?bookingId=" + bookingId)
        .then((res) => res.data);

      if (!booking) {
        this.navigateToJoyRides();
      }

      const {
        travelDate,
        schedule: selectedScheduleObj,
        seatCount: seatCountFromBooking,
        email,
        mobileNumber,
        passengerIds,
        admin: bookingAdmin,
      } = booking;

      const seats =
        bookingAdmin?.seats != null ? bookingAdmin.seats : seatCountFromBooking;
      const passengers = [];
      const source = bookingAdmin?.passengersDetails;
      if (source && Array.isArray(source) && source.length > 0) {
        for (let i = 0; i < seats; i++) {
          const p = source[i];
          passengers.push({
            name: (p && p.name) || "",
            age: (p && p.age) != null ? p.age : "",
            weight: (p && p.weight) != null ? p.weight : "",
            idNumber: (p && p.idNumber) || "",
            documentType: (p && p.documentType) || "AADHAAR",
          });
        }
      } else {
        for (let i = 0; i < seats; i++) {
          if (passengerIds && passengerIds[i]) {
            passengers.push({
              name: passengerIds[i].name || "",
              age: passengerIds[i].age || "",
              weight: passengerIds[i].weight || "",
              idNumber: passengerIds[i].idNumber || "",
              documentType: passengerIds[i].documentType || "AADHAAR",
            });
          } else {
            passengers.push({ documentType: "AADHAAR" });
          }
        }
      }

      this.setState(
        {
          travelDate,
          selectedDateFormatted: travelDate,
          loading: false,
          selectedScheduleObj,
          block: true,
          email,
          mobileNumber,
          bookingId,
          seats,
          passengers,
          bookingAdmin: bookingAdmin || null,
        },
        () => {
          this.onSeatCountChange();
          // Track Meta Pixel InitiateBooking event
          trackInitiateBooking(selectedScheduleObj);
        },
      );

      return;
    }

    if (pageState) {
      const {
        selectedDateFormatted,
        selectedScheduleObj,
        date: travelDate,
        selectedSeats = 1,
        returnUrl,
      } = pageState;

      const minimumTicketsPerBooking =
        selectedSeats || selectedScheduleObj.minimumTicketsPerBooking || 1;

      this.setState(
        {
          selectedDateFormatted,
          selectedScheduleObj: {
            ...selectedScheduleObj,
            minimumTicketsPerBooking,
          },
          travelDate,
          loading: false,
          seats: minimumTicketsPerBooking,
          ...(returnUrl && { returnUrl }),
        },
        () => {
          this.onSeatCountChange();
          // Track Meta Pixel InitiateBooking event
          trackInitiateBooking(selectedScheduleObj);
        },
      );
      return;
    }

    this.navigateToJoyRides();
  }

  navigateToJoyRides = () => {
    this.props.history.replace("/bookwithus");
  };

  validateEmail(email) {
    var re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  handleChange(field, value) {
    this.setState({
      [field]: value,
    });

    if (field === "seats") {
      this.onSeatCountChange(value);
    }
  }

  onSeatCountChange = (seatCount = this.state.seats) => {
    const { passengers, block, seats } = this.state;
    const currentSeats = passengers.length;
    const seatAllowed = block ? seats : seatCount;

    if (currentSeats < seatAllowed) {
      for (let i = 0; i < seatAllowed - currentSeats; i++) {
        passengers.push({ documentType: "AADHAAR" });
      }
    } else {
      passengers.splice(seatAllowed);
    }

    this.setState({ passengers }, () => {
      this.updateGrandPrice();
    });
  };

  calculatePassengerPrice = (passengerAge, selectedScheduleObj) => {
    if (!selectedScheduleObj || !passengerAge)
      return {
        basePrice: 0,
        gst: 0,
        total: 0,
        originalTotal: 0,
        isEarlyBirdActive: false,
        earlyBirdDiscount: null,
      };

    const basePriceItem = selectedScheduleObj.priceLineItems?.find(
      (p) => p.key === "seatCharges",
    );
    const gstItem = selectedScheduleObj.priceLineItems?.find(
      (item) => item.key === "seatChargesGst",
    );

    if (!basePriceItem) {
      // Fallback to old pricing structure
      if (selectedScheduleObj.basePrice && selectedScheduleObj.gstRate) {
        const basePrice = selectedScheduleObj.basePrice;
        const gst = basePrice * (selectedScheduleObj.gstRate / 100);
        const originalTotal = basePrice + gst;

        // Apply early bird discount if active
        const earlyBirdDiscount = selectedScheduleObj?.earlyBirdDiscount;
        const isEarlyBirdActive =
          earlyBirdDiscount?.enabled === true &&
          earlyBirdDiscount?.bookingCutoffDate &&
          moment().isSameOrBefore(moment(earlyBirdDiscount.bookingCutoffDate));

        let total = originalTotal;
        if (isEarlyBirdActive && earlyBirdDiscount?.discountAmount) {
          total = Math.max(0, originalTotal - earlyBirdDiscount.discountAmount);
        }

        return {
          basePrice,
          gst,
          total,
          originalTotal,
          isEarlyBirdActive,
          earlyBirdDiscount,
        };
      } else if (selectedScheduleObj.priceLineItems) {
        const totalPrice = selectedScheduleObj.priceLineItems.reduce(
          (acc, curr) => acc + (curr.price || 0),
          0,
        );
        const originalTotal = totalPrice * 1.05;

        // Apply early bird discount if active
        const earlyBirdDiscount = selectedScheduleObj?.earlyBirdDiscount;
        const isEarlyBirdActive =
          earlyBirdDiscount?.enabled === true &&
          earlyBirdDiscount?.bookingCutoffDate &&
          moment().isSameOrBefore(moment(earlyBirdDiscount.bookingCutoffDate));

        let total = originalTotal;
        if (isEarlyBirdActive && earlyBirdDiscount?.discountAmount) {
          total = Math.max(0, originalTotal - earlyBirdDiscount.discountAmount);
        }

        return {
          basePrice: totalPrice,
          gst: totalPrice * 0.05,
          total,
          originalTotal,
          isEarlyBirdActive,
          earlyBirdDiscount,
        };
      }
      return {
        basePrice: 0,
        gst: 0,
        total: 0,
        originalTotal: 0,
        isEarlyBirdActive: false,
        earlyBirdDiscount: null,
      };
    }

    const hasAgeBasedPrices =
      basePriceItem.ageBasedPrices &&
      Array.isArray(basePriceItem.ageBasedPrices) &&
      basePriceItem.ageBasedPrices.length > 0;

    let basePrice = 0;
    let gst = 0;

    if (hasAgeBasedPrices) {
      // Find matching age range
      const matchingAgePrice = basePriceItem.ageBasedPrices.find((agePrice) => {
        const age = parseInt(passengerAge, 10);
        return (
          age >= agePrice.minAge &&
          (agePrice.maxAge === null || age <= agePrice.maxAge)
        );
      });

      if (matchingAgePrice) {
        basePrice = matchingAgePrice.price;

        // Calculate GST
        if (gstItem?.ageBasedPrices && Array.isArray(gstItem.ageBasedPrices)) {
          const matchingGst = gstItem.ageBasedPrices.find(
            (gstAgePrice) =>
              gstAgePrice.minAge === matchingAgePrice.minAge &&
              gstAgePrice.maxAge === matchingAgePrice.maxAge,
          );
          gst = matchingGst?.price || basePrice * 0.05;
        } else {
          gst = basePrice * 0.05;
        }
      }
    } else {
      basePrice = basePriceItem.price || 0;
      if (gstItem?.price !== undefined) {
        gst = gstItem.price;
      } else {
        gst = basePrice * 0.05;
      }
    }

    const originalTotal = Math.round(basePrice + gst);

    // Apply early bird discount if active
    const earlyBirdDiscount = selectedScheduleObj?.earlyBirdDiscount;
    const isEarlyBirdActive =
      earlyBirdDiscount?.enabled === true &&
      earlyBirdDiscount?.bookingCutoffDate &&
      moment().isSameOrBefore(moment(earlyBirdDiscount.bookingCutoffDate));

    let total = originalTotal;
    if (isEarlyBirdActive && earlyBirdDiscount?.discountAmount) {
      total = Math.max(0, originalTotal - earlyBirdDiscount.discountAmount);
    }

    return {
      basePrice,
      gst: Math.round(gst),
      total,
      originalTotal,
      isEarlyBirdActive,
      earlyBirdDiscount,
    };
  };

  calculateGrandTotal = () => {
    const { passengers, selectedScheduleObj } = this.state;
    let total = 0;

    passengers.forEach((passenger) => {
      if (passenger.age) {
        const price = this.calculatePassengerPrice(
          passenger.age,
          selectedScheduleObj,
        );
        // calculatePassengerPrice already applies the discount, so just use price.total
        total += price.total;
      }
    });

    return total;
  };

  updateGrandPrice = () => {
    const total = this.calculateGrandTotal();
    this.setState({
      grandprice: `₹ ${total.toLocaleString()}`,
    });
  };

  hasAnyPassengerAge = () => {
    const { passengers } = this.state;
    return passengers.some((passenger) => passenger && passenger.age);
  };

  addPassengerDetails = (index, field, value) => {
    const { passengers } = this.state;
    passengers[index][field] = value;
    this.setState({ passengers }, () => {
      // Recalculate price when age changes
      if (field === "age") {
        this.updateGrandPrice();
      }
    });
  };

  isFormValid = () => {
    const { email, mobileNumber, errors, seats, passengers } = this.state;
    let isFormValid = true;

    if (!this.validateEmail(email)) {
      errors.email = true;
      isFormValid = false;
    } else {
      errors.email = false;
    }

    if (!mobileNumber || !`${mobileNumber}`.trim().length === 10) {
      errors.mobileNumber = true;
      isFormValid = false;
    } else {
      errors.mobileNumber = false;
    }

    for (let i = 0; i < seats; i++) {
      const passenger = passengers[i];

      if (!passenger || !passenger.age || parseInt(passenger.age, 10) <= 0) {
        isFormValid = false;
        if (errors.passengers.age.indexOf(i) === -1)
          errors.passengers.age.push(i);
      } else {
        if (errors.passengers.age.indexOf(i) !== -1) {
          const index = errors.passengers.age.indexOf(i);
          errors.passengers.age.splice(index, 1);
        }
      }

      if (!passenger || !passenger.name || passenger.name.trim().length <= 2) {
        isFormValid = false;
        if (errors.passengers.name.indexOf(i) === -1)
          errors.passengers.name.push(i);
      } else {
        if (errors.passengers.name.indexOf(i) !== -1) {
          const index = errors.passengers.name.indexOf(i);
          errors.passengers.name.splice(index, 1);
        }
      }

      if (
        !passenger ||
        !passenger.weight ||
        parseInt(passenger.weight, 10) <= 1
      ) {
        isFormValid = false;
        if (errors.passengers.weight.indexOf(i) === -1)
          errors.passengers.weight.push(i);
      } else {
        if (errors.passengers.weight.indexOf(i) !== -1) {
          const index = errors.passengers.weight.indexOf(i);
          errors.passengers.weight.splice(index, 1);
        }
      }

      if (
        !passenger ||
        !passenger.idNumber ||
        passenger.idNumber.trim().length <= 2
      ) {
        isFormValid = false;
        if (errors.passengers.idNumber.indexOf(i) === -1)
          errors.passengers.idNumber.push(i);
      } else {
        if (errors.passengers.idNumber.indexOf(i) !== -1) {
          const index = errors.passengers.idNumber.indexOf(i);
          errors.passengers.idNumber.splice(index, 1);
        }
      }
    }

    this.setState({
      errors: {
        ...this.state.errors,
        ...errors,
      },
      isFormValid,
    });

    return isFormValid;
  };

  async createbooking() {
    const isFormValid = this.isFormValid();
    if (!isFormValid) return false;
    this.setState({ loading: true });
    const {
      selectedScheduleObj: { _id: schedule },
      travelDate,
      seats: seatCount,
      passengers,
      email,
      bookingId,
      mobileNumber,
      block,
    } = this.state;

    const utmSource = this.getQueryParam("utm_source");

    var payload = {
      bookingId: block ? bookingId : undefined,
      schedule,
      travelDate,
      seatCount,
      passengers: JSON.stringify(passengers),
      email,
      mobileNumber,
      utmSource: utmSource || undefined,
    };
    try {
      const response = await axios({
        url: block
          ? config.baseUrl + "v2/booking/block"
          : config.baseUrl + "booking/joyride",
        method: block ? "put" : "post",
        data: payload,
      });
      this.setState({ loading: false });
      let state = { dialog: {}, bookingResponse: {} };

      if (response.data.status === "success") {
        state.bookingResponse = response.data;

        if (response.data.orderId && response.data.key_id) {
          this.setState(
            {
              ...this.state,
              ...state,
              loading: false,
              bookingId: response.data.bookingId,
            },
            () => {
              this.openRazorpayModal(response.data);
            },
          );
          return;
        } else {
          state.dialog.success = true;
          state.dialog.error = false;
        }
      } else {
        state.bookingResponse.message = response.data.message;
        state.dialog.error = true;
        state.dialog.success = false;
      }

      this.setState({
        ...this.state,
        ...state,
        loading: false,
      });
    } catch (err) {
      this.setState({
        ...this.state,
        dialog: {
          error: true,
          success: false,
        },
        loading: false,
        bookingResponse: {
          message: "Uh oh! Something has gone wrong !",
        },
      });
    }
  }

  closeDialog = () => {
    this.setState({
      dialog: {
        error: false,
        success: false,
      },
    });
  };

  openRazorpayModal = (paymentData) => {
    const {
      orderId,
      amount,
      key_id,
      customer,
      description,
      currency = "INR",
      bookingId,
    } = paymentData;

    if (!window.Razorpay) {
      console.error("Razorpay script not loaded");
      alert(
        "Payment gateway is not available. Please refresh the page and try again.",
      );
      return;
    }

    this.setState({
      loading: true,
      loadingMessage: "Processing your payment...",
    });

    const options = {
      key: key_id,
      amount: amount * 100,
      currency: currency,
      name: "Helitaxii",
      description: description || "Helitaxii Joy Ride",
      order_id: orderId,
      prefill: {
        contact: customer?.contact || "",
        email: customer?.email || "",
      },
      handler: (razorpayResponse) => {
        this.handlePaymentSuccess(razorpayResponse, bookingId);
      },
      modal: {
        ondismiss: () => {
          console.log("Payment modal closed by user");
          this.setState({ loading: false });
        },
      },
      theme: {
        color: "#005299",
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  handlePaymentSuccess = async (razorpayResponse, bookingId) => {
    this.setState({
      loading: true,
      loadingMessage: "Hold Tight! We are holding your tickets",
    });

    try {
      const response = await axios.post(
        config.baseUrl + "v2/booking/verify-payment",
        {
          bookingId: bookingId,
          paymentId: razorpayResponse.razorpay_payment_id,
          orderId: razorpayResponse.razorpay_order_id,
          signature: razorpayResponse.razorpay_signature,
        },
      );

      if (response.data.status === "success") {
        this.closeDialog();

        // Google Ads Conversion Tracking
        // Fire conversion event on successful payment for tracked programs
        this.trackConversion(bookingId);

        const bookingData = {
          bookingId: bookingId,
          schedule: this.state.selectedScheduleObj,
          travelDate: this.state.selectedDateFormatted || this.state.travelDate,
          seatCount: this.state.seats,
          passengers: this.state.passengers,
          email: this.state.email,
          mobileNumber: this.state.mobileNumber,
          grandprice: this.state.grandprice,
        };
        const state = { bookingData };
        if (this.state.bookingAdmin) {
          state.admin = this.state.bookingAdmin;
        }

        setTimeout(() => {
          this.props.history.push({
            pathname: "/booking-confirmation",
            state,
          });
        }, 300);
      } else {
        this.setState({ loading: false });
        alert(
          "Payment verification failed. Please contact support with your booking ID: " +
            bookingId,
        );
      }
    } catch (error) {
      console.error("Payment verification error:", error);
      this.setState({ loading: false });
      alert(
        "There was an error verifying your payment. Please contact support with your booking ID: " +
          bookingId,
      );
    }
  };

  isSeatChoiceValid = (seat) => {
    const { selectedScheduleObj } = this.state;
    const { minimumTicketsPerBooking = 1 } = selectedScheduleObj || {};

    return seat >= minimumTicketsPerBooking;
  };

  // Check if current booking should trigger conversion tracking
  shouldTrackConversion = () => {
    const { conversionTracking } = config;
    const { selectedScheduleObj } = this.state;

    if (!conversionTracking?.enabled || !selectedScheduleObj) {
      return false;
    }

    const { program, type } = selectedScheduleObj;
    const { trackedPrograms } = conversionTracking;

    // Check if this program/type combination is in the tracked list
    return trackedPrograms.some(
      (tracked) =>
        tracked.program === program && (!tracked.type || tracked.type === type),
    );
  };

  // Fire Google Ads conversion event
  trackConversion = (bookingId) => {
    if (!this.shouldTrackConversion()) {
      return;
    }

    const { conversionTracking } = config;

    if (typeof window.gtag === "function" && conversionTracking) {
      const totalAmount = this.calculateGrandTotal();
      const sendTo = `${conversionTracking.googleAdsId}/${conversionTracking.conversionLabel}`;

      window.gtag("event", "conversion", {
        send_to: sendTo,
        value: totalAmount,
        currency: conversionTracking.currency || "INR",
        transaction_id: bookingId,
      });

      console.log("Conversion tracked:", {
        sendTo,
        value: totalAmount,
        bookingId,
        program: this.state.selectedScheduleObj?.program,
        type: this.state.selectedScheduleObj?.type,
      });
    }
  };

  render() {
    const {
      selectedScheduleObj,
      selectedDateFormatted,
      grandprice,
      seats,
      errors,
      block,
      dialog,
      bookingResponse,
      passengers,
    } = this.state;

    var passengerRows = [];

    for (let i = 0; i < seats; i++) {
      const passenger = passengers[i] || {};
      const passengerAge = passenger.age;
      const passengerPrice = this.calculatePassengerPrice(
        passengerAge,
        selectedScheduleObj,
      );

      // Generate price breakdown tooltip content - only for passenger's age group
      const basePriceItem = selectedScheduleObj?.priceLineItems?.find(
        (p) => p.key === "seatCharges",
      );
      const gstItem = selectedScheduleObj?.priceLineItems?.find(
        (item) => item.key === "seatChargesGst",
      );
      const hasAgeBasedPrices =
        basePriceItem?.ageBasedPrices &&
        Array.isArray(basePriceItem.ageBasedPrices) &&
        basePriceItem.ageBasedPrices.length > 0;

      // Find the matching age group for this passenger
      let matchingAgePrice = null;
      if (hasAgeBasedPrices && passengerAge) {
        const age = parseInt(passengerAge, 10);
        matchingAgePrice = basePriceItem.ageBasedPrices.find((agePrice) => {
          return (
            age >= agePrice.minAge &&
            (agePrice.maxAge === null || age <= agePrice.maxAge)
          );
        });
      }

      const tooltipContent =
        hasAgeBasedPrices && matchingAgePrice ? (
          <div style={{ padding: "4px 0", minWidth: "200px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "4px",
                fontSize: "12px",
                color: "#666",
                gap: "16px",
              }}
            >
              <span>Base:</span>
              <span>₹ {matchingAgePrice.price.toLocaleString()}</span>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "6px",
                fontSize: "12px",
                color: "#666",
                gap: "16px",
              }}
            >
              <span>GST:</span>
              <span>
                ₹{" "}
                {Math.round(
                  gstItem?.ageBasedPrices &&
                    Array.isArray(gstItem.ageBasedPrices)
                    ? (() => {
                        const matchingGst = gstItem.ageBasedPrices.find(
                          (gstAgePrice) =>
                            gstAgePrice.minAge === matchingAgePrice.minAge &&
                            gstAgePrice.maxAge === matchingAgePrice.maxAge,
                        );
                        return (
                          matchingGst?.price || matchingAgePrice.price * 0.05
                        );
                      })()
                    : matchingAgePrice.price * 0.05,
                ).toLocaleString()}
              </span>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "13px",
                fontWeight: 600,
                color: "#005299",
                borderTop: "1px solid #e8e8e8",
                paddingTop: "6px",
                gap: "16px",
              }}
            >
              <span>Total:</span>
              <span>
                ₹{" "}
                {(
                  passengerPrice.originalTotal ||
                  passengerPrice.total ||
                  0
                ).toLocaleString()}
              </span>
            </div>
            {passengerPrice.isEarlyBirdActive &&
              passengerPrice.earlyBirdDiscount?.discountAmount && (
                <>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: "12px",
                      color: "#d97706",
                      marginTop: "6px",
                      paddingTop: "6px",
                      borderTop: "1px solid #e8e8e8",
                      gap: "16px",
                    }}
                  >
                    <span>Early Bird Discount:</span>
                    <span>
                      -₹{" "}
                      {passengerPrice.earlyBirdDiscount.discountAmount.toLocaleString()}
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: "13px",
                      fontWeight: 600,
                      color: "#005299",
                      marginTop: "4px",
                      paddingTop: "4px",
                      borderTop: "1px solid #e8e8e8",
                      gap: "16px",
                    }}
                  >
                    <span>Final Price:</span>
                    <span>₹ {passengerPrice.total.toLocaleString()}</span>
                  </div>
                </>
              )}
          </div>
        ) : (
          <div style={{ padding: "4px 0", minWidth: "200px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "4px",
                fontSize: "12px",
                color: "#666",
                gap: "16px",
              }}
            >
              <span>Base:</span>
              <span>₹ {basePriceItem?.price?.toLocaleString() || "0"}</span>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "6px",
                fontSize: "12px",
                color: "#666",
                gap: "16px",
              }}
            >
              <span>GST:</span>
              <span>
                ₹{" "}
                {Math.round(
                  basePriceItem?.price ? basePriceItem.price * 0.05 : 0,
                ).toLocaleString()}
              </span>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "13px",
                fontWeight: 600,
                color: "#005299",
                borderTop: "1px solid #e8e8e8",
                paddingTop: "6px",
                gap: "16px",
              }}
            >
              <span>Total:</span>
              <span>
                ₹{" "}
                {(
                  passengerPrice.originalTotal ||
                  passengerPrice.total ||
                  0
                ).toLocaleString()}
              </span>
            </div>
            {passengerPrice.isEarlyBirdActive &&
              passengerPrice.earlyBirdDiscount?.discountAmount && (
                <>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: "12px",
                      color: "#d97706",
                      marginTop: "6px",
                      paddingTop: "6px",
                      borderTop: "1px solid #e8e8e8",
                      gap: "16px",
                    }}
                  >
                    <span>Early Bird Discount:</span>
                    <span>
                      -₹{" "}
                      {passengerPrice.earlyBirdDiscount.discountAmount.toLocaleString()}
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: "13px",
                      fontWeight: 600,
                      color: "#005299",
                      marginTop: "4px",
                      paddingTop: "4px",
                      borderTop: "1px solid #e8e8e8",
                      gap: "16px",
                    }}
                  >
                    <span>Final Price:</span>
                    <span>₹ {passengerPrice.total.toLocaleString()}</span>
                  </div>
                </>
              )}
          </div>
        );

      passengerRows.push(
        <div key={i} className="col-md-12" style={{ marginTop: "20px" }}>
          <div
            className="passenger-card"
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "8px",
              border: "1px solid #e8e8e8",
              boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
              padding: "4px 12px 12px 12px",
              width: "100%",
            }}
          >
            <div className="passenger-card-container">
              <div
                className="passenger-field-wrapper"
                style={{ width: "180px" }}
              >
                <TextField
                  label="Name"
                  type="text"
                  value={passenger.name || ""}
                  error={errors.passengers.name.indexOf(i) !== -1}
                  onChange={(e) => {
                    this.addPassengerDetails(i, "name", e.target.value);
                  }}
                  margin="normal"
                  variant="outlined"
                  fullWidth
                />
              </div>
              <div
                className="passenger-field-wrapper"
                style={{ width: "120px" }}
              >
                <TextField
                  label="Age"
                  type="number"
                  value={passengerAge || ""}
                  onChange={(e) => {
                    this.addPassengerDetails(
                      i,
                      "age",
                      parseInt(e.target.value, 10) || "",
                    );
                  }}
                  error={errors.passengers.age.indexOf(i) !== -1}
                  margin="normal"
                  variant="outlined"
                  fullWidth
                />
              </div>
              <div
                className="passenger-field-wrapper"
                style={{ width: "120px" }}
              >
                <TextField
                  label="Weight (kg)"
                  type="number"
                  value={passenger.weight || ""}
                  margin="normal"
                  onChange={(e) => {
                    this.addPassengerDetails(
                      i,
                      "weight",
                      parseInt(e.target.value, 10) || "",
                    );
                  }}
                  error={errors.passengers.weight.indexOf(i) !== -1}
                  variant="outlined"
                  fullWidth
                />
              </div>
              <div
                className="passenger-field-wrapper"
                style={{ width: "120px" }}
              >
                <TextField
                  select
                  label="Id"
                  value={passenger.documentType || "AADHAAR"}
                  onChange={(e) => {
                    this.addPassengerDetails(i, "documentType", e.target.value);
                  }}
                  margin="normal"
                  variant="outlined"
                  fullWidth
                >
                  <MuiMenuItem value="AADHAAR">Aadhar</MuiMenuItem>
                  <MuiMenuItem value="PASSPORT">Passport</MuiMenuItem>
                </TextField>
              </div>
              <div
                className="passenger-field-wrapper"
                style={{ width: "180px" }}
              >
                <TextField
                  label={
                    (passenger.documentType || "AADHAAR") === "PASSPORT"
                      ? "Passport Number"
                      : "Aadhar Number"
                  }
                  type="text"
                  value={passenger.idNumber || ""}
                  onChange={(e) => {
                    this.addPassengerDetails(i, "idNumber", e.target.value);
                  }}
                  error={errors.passengers.idNumber.indexOf(i) !== -1}
                  margin="normal"
                  variant="outlined"
                  fullWidth
                />
              </div>
              <div className="passenger-price-container">
                {passengerAge ? (
                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "baseline",
                      gap: "6px",
                      flexWrap: "wrap",
                    }}
                    className="price-animate"
                  >
                    {passengerPrice.isEarlyBirdActive &&
                    passengerPrice.earlyBirdDiscount?.discountAmount ? (
                      <>
                        <span
                          style={{
                            color: "#005299",
                            fontSize: "20px",
                            fontWeight: 700,
                            lineHeight: 1,
                          }}
                        >
                          ₹ {passengerPrice.total.toLocaleString()}
                        </span>
                        <span
                          style={{
                            textDecoration: "line-through",
                            color: "#999",
                            fontSize: "16px",
                            fontWeight: 400,
                            lineHeight: 1,
                          }}
                        >
                          ₹{" "}
                          {(
                            passengerPrice.originalTotal ||
                            passengerPrice.total ||
                            0
                          ).toLocaleString()}
                        </span>
                      </>
                    ) : (
                      <span
                        style={{
                          color: "#005299",
                          fontSize: "20px",
                          fontWeight: 700,
                          lineHeight: 1,
                        }}
                      >
                        ₹ {passengerPrice.total.toLocaleString()}
                      </span>
                    )}
                    <Popover
                      content={tooltipContent}
                      title={null}
                      trigger="click"
                      placement="right"
                    >
                      <Button
                        type="text"
                        icon={<InfoCircleOutlined />}
                        style={{
                          color: "#005299",
                          padding: "4px",
                          height: "auto",
                          border: "none",
                          fontSize: "16px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      />
                    </Popover>
                  </div>
                ) : (
                  <div style={{ width: "180px" }} />
                )}
              </div>
            </div>
          </div>
        </div>,
      );
    }

    return (
      <div>
        <DialogSuccess
          open={dialog.success}
          data={bookingResponse}
          block={block}
          returnUrl={this.state.returnUrl}
          onClose={this.closeDialog}
          onPayment={this.openRazorpayModal}
        />
        <DialogError
          open={dialog.error}
          data={bookingResponse}
          handleClose={this.closeDialog}
        />
        <PaymentLoader
          loading={this.state.loading}
          text={this.state.loadingMessage}
        />
        <section className="home-jumbotron" style={{ background: "none" }}>
          <div className="joyrideItemContainerBooking">
            <div className="container" style={{ border: "1px solid black" }}>
              <div className="row ">
                <div
                  style={{
                    display: "block",
                    width: "100%",
                    fontWeight: 500,
                    paddingLeft: "15px",
                    textAlign: "center",
                    padding: "20px 0",
                  }}
                >
                  <div
                    style={{
                      fontSize: "18px",
                      borderBottom: "1px solid black",
                      display: "inline-block",
                    }}
                  >
                    Ticket Details
                  </div>
                </div>

                {selectedScheduleObj &&
                  selectedScheduleObj.type === "joyride" && (
                    <div className="col-md-3">
                      <h4 style={{ fontSize: "18px" }}>Flying at</h4>
                      <h3>
                        {selectedScheduleObj &&
                          selectedScheduleObj.path.halts[0].name}
                      </h3>
                    </div>
                  )}

                {selectedScheduleObj &&
                  selectedScheduleObj.type === "shuttle" && (
                    <div className="col-md-12">
                      <h4 style={{ fontSize: "18px" }}>Shuttle</h4>
                      <h3>
                        {selectedScheduleObj && selectedScheduleObj.path.name}
                      </h3>
                    </div>
                  )}
                <div className="col-md-3">
                  <h4>Date</h4>
                  <h3>{selectedDateFormatted}</h3>
                </div>
                <div className="col-md-6">
                  <h4>Timings</h4>
                  <h3>{selectedScheduleObj && selectedScheduleObj.name}</h3>
                </div>
                <div className="row ridedetails ridedetailsinfo">
                  <div className="form-group col-md-3">
                    <TextField
                      fullWidth
                      label="Email Address"
                      disabled={block}
                      variant="outlined"
                      error={errors.email}
                      value={this.state.email}
                      onChange={(e) =>
                        this.handleChange("email", e.target.value)
                      }
                      margin="normal"
                    />
                  </div>
                  <div className="form-group col-md-3">
                    <TextField
                      fullWidth
                      label="Mobile Number"
                      disabled={block}
                      error={errors.mobileNumber}
                      value={this.state.mobileNumber}
                      variant="outlined"
                      onChange={(e) =>
                        this.handleChange("mobileNumber", e.target.value)
                      }
                      margin="normal"
                    />
                  </div>
                  <div className="form-group col-md-3">
                    <SelectField
                      floatingLabelText="Seats"
                      disabled={block}
                      style={{ width: "100px" }}
                      variant="outlined"
                      onChange={(e, i, v) => this.handleChange("seats", v)}
                      value={seats}
                    >
                      {[1, 2, 3, 4, 5, 6]
                        .filter(this.isSeatChoiceValid)
                        .map((i) => (
                          <MenuItem primaryText={`${i}`} value={i} key={i} />
                        ))}
                    </SelectField>
                  </div>
                  <div
                    style={{
                      display: "block",
                      width: "100%",
                      fontSize: "16px",
                      fontWeight: 500,
                      paddingLeft: "15px",
                    }}
                  >
                    Passenger Details
                  </div>
                  {passengerRows}

                  <div className="form-group col-md-12 booking-button-container">
                    {this.hasAnyPassengerAge() && (
                      <button
                        type="button"
                        className="btn btn-success booking-pay-button price-animate"
                        style={{ float: "right", padding: "10px" }}
                        onClick={this.createbooking.bind(this)}
                      >
                        Pay {grandprice}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <FooterComponent />
      </div>
    );
  }
}

export default JoyRideBookingComponent;
